import { Upload, Ruler, CreditCard, Package } from "lucide-react";
import { useLang } from "@/lib/i18n";

const STEPS = [
  { k: "s1", icon: Upload, c: "text-gold" },
  { k: "s2", icon: Ruler, c: "text-fire" },
  { k: "s3", icon: CreditCard, c: "text-ruby" },
  { k: "s4", icon: Package, c: "text-cap" },
];

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-testid="how-section">
      <h2 className="font-display text-3xl sm:text-4xl">{t("how.title")}</h2>
      <ol className="mt-12 grid gap-px overflow-hidden rounded-lg border border-white/10 bg-white/10 md:grid-cols-4">
        {STEPS.map(({ k, icon: Icon, c }, i) => (
          <li key={k} className="bg-ink p-7" data-testid={`how-step-${i + 1}`}>
            <div className="flex items-center justify-between">
              <Icon className={`h-7 w-7 ${c}`} />
              <span className="font-display text-4xl text-white/10">0{i + 1}</span>
            </div>
            <h3 className="mt-6 text-lg font-extrabold">{t(`how.${k}`)}</h3>
            <p className="mt-2 text-sm text-slate-400">{t(`how.${k}d`)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};
